// extracted by mini-css-extract-plugin
export default {"container":"ShowcaseHomeDark_container__rqP1P","ShowcaseHome":"ShowcaseHomeDark_ShowcaseHome__BQLrs","ShowcaseBody":"ShowcaseHomeDark_ShowcaseBody__ttQ0W"};